import { create } from "zustand";

export const useAgeGroups = create((set) => ({
  ageGroups: [],
  addAgeGroups: (data: any) => set(() => ({ ageGroups: data })),
}));
